<div  class="adviser-dimentation " (click)="$event.stopPropagation();">
	<mat-form-field  style="width: 100%!important;" >
		<mat-icon matSuffix>search</mat-icon>
		<input matInput class="adviser-dimentation"   placeholder="Advisor (Team/Rep Id) Search" 
			[formControl]="searchControl"
			>
		<button *ngIf="searchControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchControl.setValue('')">
			<mat-icon class="font18">close</mat-icon>
		</button>
	</mat-form-field>    
	<div>
		<mat-tree class="bg-white p-2 " [dataSource]="dataSource" [treeControl]="treeControl">
			<mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding >
				<button   mat-icon-button disabled></button>
				<div>
					<div>
						<mat-checkbox class="checklist-leaf-node" 
							[checked]="checklistSelection.isSelected(node)"
							(change)="checklistSelection.toggle(node);"
							[ngStyle]="{'color': node.color}" class="">{{node.item}}
						</mat-checkbox>					
					</div>				
				</div>
			</mat-tree-node>
			<mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding >
				<button   mat-icon-button matTreeNodeToggle 
				[attr.aria-label]="'toggle ' + node.filename">
					<mat-icon class="mat-icon-rtl-mirror"> 
						{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
					</mat-icon>
				</button>
				<mat-checkbox [checked]="descendantsAllSelected(node)"
                    [indeterminate]="descendantsPartiallySelected(node)"
                    (change)="todoItemSelectionToggle(node)"
					[ngStyle]="{'color': node.color}" class="">{{node.item}}</mat-checkbox>
			</mat-tree-node>
		</mat-tree>  
	</div>
</div>
<hr>
<div class="d-flex bg-white p-2 m-0 align-middle">
	<a mat-button color="primary"  (click)="clearFilter();$event.stopPropagation();">Clear All</a>		
	<div></div>
	<a mat-button  (click)="cancel()">Cancel</a>	
	
	<!-- <a mat-stroked-button color="accent" class="p-10 m-r10" (click)="clearFilter();$event.stopPropagation();">Clear</a> -->
	<a mat-stroked-button color="accent" class="p-t5" (click)="applyFilter()">Apply</a>
</div>